var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadOutlined = function SvgDownloadOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeWidth: 1.321,
    d: "M18.558 10.883a.264.264 0 0 0-.187-.45h-3.65V4H8.288v6.432h-3.65a.264.264 0 0 0-.187.451l6.867 6.867c.103.103.27.103.373 0zM4.153 21h14.703"
  })));
};
export default SvgDownloadOutlined;